// extracted by mini-css-extract-plugin
export default {"parkersPage":"ParkersPage_parkersPage__vVgOC","parkersContainer":"ParkersPage_parkersContainer__7P4rx","box":"ParkersPage_box__-+5TP","item":"ParkersPage_item__U++Tf"};